import React, { Component } from 'react'
import { Spin } from 'antd'

export default class loadingResource extends Component {
    render() {
        return (
            <div>
                <Spin size="large" tip="正在加载资源..." />
            </div>
        )
    }
}
